module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-SemiBold-WebM-edb256825e56eb850d79c6a3f3fa13c5.woff2";